export default {
  reviewerProfile: {
    id: 'product_review_display_reviewer_profile',
    defaultMessage: '{userName, html} reviewer profile',
  },
  reviewerCustomerSince: {
    id: 'product_review_display_reviewer_customer_since',
    defaultMessage: 'Customer since {sinceDate}',
  },
  reviewerPurchaseCount: {
    id: 'product_review_display_reviewer_purchase_count',
    defaultMessage: '{purchaseCount} verifier purchases',
  },
  reviewerReviewCount: {
    id: 'product_review_display_reviewer_review_count',
    defaultMessage: '{reviewCount} reviews',
  },
  reviewerAverageRating: {
    id: 'product_review_display_reviewer_average_rating',
    defaultMessage: 'Rating average of {averageRating} stars',
  },
} as const
